import React from 'react';
import { TouchableOpacity, Text, StyleSheet, ViewStyle, StyleProp, TextStyle } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

type TButtonGeneralProps = {
  onPress: () => void;
  title: string;
  colors?: string[];
  width?: number;
  height?: number;
  fontSize?: number;
  nameContainerStyle?: StyleProp<ViewStyle>;
  fontStyle?: StyleProp<TextStyle>;
};

export default function ButtonGeneral(props: TButtonGeneralProps) {
  const {
    onPress,
    title,
    width = 303,
    height = 65,
    fontSize = 16,
    colors = ['#FFCF53', '#FF9900'],
    nameContainerStyle,
    fontStyle,
  } = props;

  return (
    <TouchableOpacity onPress={onPress}>
      <LinearGradient
        style={[styles.nameContainer, { width, height }, nameContainerStyle]}
        colors={colors}
      >
        <Text maxFontSizeMultiplier={1} style={[styles.startButtonText, fontStyle, { fontSize }]}>
          {title}
        </Text>
      </LinearGradient>
    </TouchableOpacity>
  );
}
const styles = StyleSheet.create({
  nameContainer: {
    borderRadius: 12,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  startButtonText: {
    fontFamily: 'Secular One',
    marginRight: 6,
    marginTop: 4,
    color: '#000000',
    fontSize: 16,
  },
});
